import { addMethod, string, StringSchema, DateSchema, date } from 'yup';

function isValidPanCard(this: StringSchema, message: string) {
  return this.matches(/^([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}$/, message);
}

addMethod(string, 'pancard', isValidPanCard);

function isValidPanCardForIndividual(this: StringSchema, message: string) {
  return this.matches(
    /^([A-Za-z]){3}([Pp]){1}([A-Za-z]){1}([0-9]){4}([A-Za-z]){1}$/,
    message
  );
}
addMethod(string, 'individualPancard', isValidPanCardForIndividual);
//pending for milan sir
function isValidPanCardForCompany(this: StringSchema, message: string) {
  // return this.matches(
  //   /^([A-Za-z]){3}([^Pp]){1}([A-Za-z]){1}([0-9]){4}([A-Za-z]){1}$/,
  //   message
  // );
  return this.matches(/^([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}$/, message);
}
addMethod(string, 'companyPancard', isValidPanCardForCompany);

function isValidPanCardForIndividualOptional(
  this: StringSchema,
  message: string
) {
  return this.matches(
    /^([A-Za-z]){3}([Pp]){1}([A-Za-z]){1}([0-9]){4}([A-Za-z]){1}$/,
    message
  );
}
addMethod(
  string,
  'individualPancardOptional',
  isValidPanCardForIndividualOptional
);
//pending for milan sir
function isValidPanCardForCompanyOptional(this: StringSchema, message: string) {
  // return this.matches(
  //   /^([A-Za-z]){3}([^Pp]){1}([A-Za-z]){1}([0-9]){4}([A-Za-z]){1}$/,
  //   message
  // );
  return this.matches(/^([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}$/, message);
}
addMethod(string, 'companyPancardOptional', isValidPanCardForCompanyOptional);

function isValidGSTIN(this: StringSchema, message: string) {
  return this.matches(/^([A-Za-z0-9]){15}$/, message);
  // return this.matches(/^([0-9]){2}([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}([0-9]){1}([zZ]){1}([0-9]){1}$/, message);
}
addMethod(string, 'gstin', isValidGSTIN);

function isValidGSTNo(this: StringSchema, message: string) {
  // “^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$”;
  return this.matches(
    /^([0-9]){2}([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}([0-9]){1}([Zz]){1}([0-9]){1}$/,
    message
  );
}
addMethod(string, 'gstNumber', isValidGSTNo);

function isValidAadharCard(this: StringSchema, message: string) {
  return this.matches(/^\d{4}\d{4}\d{4}$/, message);
}

addMethod(string, 'aadhar', isValidAadharCard);

function futureDateNotAllowed(this: DateSchema, message: string) {
  return this.max(new Date(), message);
}

addMethod(date, 'futureDateNotAllowed', futureDateNotAllowed);

function isValidEmail(this: StringSchema, message: string) {
  ///^\S+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/
  return this.matches(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/, message);
}

addMethod(string, 'email', isValidEmail);

function isValidGST(this: StringSchema, message: string) {
  return this.matches(
    /^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}[0-9A-Za-z]{1}[0-9A-Za-z]{1}$/,
    message
  );
}
addMethod(string, 'gst', isValidGST);
